export default __webpack_public_path__ + "static/media/insurance-policy.86ccb133.jpeg";